import React, { FC } from 'react';
import { Heading, Paragraph } from '@digdir/designsystemet-react';
import { useTranslation } from 'react-i18next';

import { Soknad } from '../../../../types/building';
import { useEnergiplanRegistrations } from '../../hooks/useEnergiplanRegistrations';
import { Tilstand } from '../tilstand';
import { TilstandCard, TintedCard } from '../styledComponents';

import { CreateSluttilstandButton } from './createSluttilstandButton';

interface Props {
  soknad?: Soknad;
}

export const Sluttilstand: FC<Props> = ({ soknad }) => {
  const { t } = useTranslation('', { keyPrefix: 'screens.energiplan.components.sluttilstand' });
  const { energyAnalysisSteg2, energyAnalysisSteg3 } = useEnergiplanRegistrations(soknad);

  const steg2IsDone = !!energyAnalysisSteg2?.energiplan?.energimerke?.properties?.lukketSoknadSteg2;
  const steg3Energiplan = energyAnalysisSteg3?.energiplan;

  if (!steg2IsDone) {
    return (
      <TilstandCard>
        <Paragraph data-size="xs">{t('estimateText')}</Paragraph>
      </TilstandCard>
    );
  }

  if (!steg3Energiplan) {
    return (
      <TintedCard>
        <Heading data-size="sm">{t('title')}</Heading>
        <Paragraph data-size="xs">{t('noEnergiplan')}</Paragraph>
        <div>
          <CreateSluttilstandButton registrering={energyAnalysisSteg2.registrering} />
        </div>
      </TintedCard>
    );
  }

  return <Tilstand title={t('title')} energiplan={steg3Energiplan} />;
};
